import React, { useEffect, useRef } from 'react';

function UserStatisticsHandler({ user, socket }) {
  const timerRef = useRef(null); // Use a ref to persist the timer across renders

  useEffect(() => {
    const sendUserData = () => {
      if (user) {
        socket.socket.emit('getUserData'); // Emit the 'getUserData' event
        timerRef.current = setTimeout(sendUserData, 3000); // Schedule the next call in 30 seconds
      }
    };

    if (user && !timerRef.current) {
      sendUserData(); // Start the loop only if the user exists and no timer is active
    }
  }, [user]); // Dependencies: re-run only if `user` or `socket` changes

  return null; // This component does not render anything
}

export default UserStatisticsHandler;